/**
 * NewLeadDialog — Iter 156.10. Extracted from `LeadsPage.jsx`.
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "../../components/ui/dialog";

export default function NewLeadDialog({
  showNewLead, setShowNewLead, newLeadData, setNewLeadData, handleCreateLead,
}) {
  return (
    <Dialog open={showNewLead} onOpenChange={setShowNewLead}>
      <DialogContent className="bg-[#FDFBF7] border-[#E7E5E4]">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Playfair Display, serif" }} className="text-xl">
            Add New Lead
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleCreateLead} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Name *</label>
            <input
              type="text"
              value={newLeadData.name}
              onChange={(e) => setNewLeadData((prev) => ({ ...prev, name: e.target.value }))}
              className="form-input"
              required
              data-testid="new-lead-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Phone *</label>
            <input
              type="tel"
              value={newLeadData.phone}
              onChange={(e) => setNewLeadData((prev) => ({ ...prev, phone: e.target.value }))}
              className="form-input"
              placeholder="+91 9876543210"
              required
              data-testid="new-lead-phone"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Initial Message</label>
            <textarea
              value={newLeadData.message}
              onChange={(e) => setNewLeadData((prev) => ({ ...prev, message: e.target.value }))}
              className="form-input min-h-[80px]"
              data-testid="new-lead-message"
            />
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" onClick={() => setShowNewLead(false)} className="btn-secondary">
              Cancel
            </button>
            <button type="submit" className="btn-primary" data-testid="submit-new-lead">
              Create Lead
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
